/** Available notification target statuses */
export enum NotificationTargetStatusEnum {
  /** Notification pending */
  PENDING = 'PENDING',
  /** Notification sent to target */
  SENT = 'SENT',
  /** Notification read by target */
  READ = 'READ',
}
